<template>
  <q-form ref="editForm">
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <c-card title="KOSHA 기본정보" class="cardClassDetailForm">
          <template slot="card-button">
            <q-btn-group outline >
              <c-btn
                v-if="editable"
                :url="saveUrl"
                :isSubmit="isSave"
                :param="folderDetail"
                :mappingType="saveType"
                label="저장"
                icon="save"
                @beforeAction="saveFolderDetail"
                @btnCallback="saveCallback" 
              />
              <c-btn v-if="editable && popupParam.koshaFolderDetailId" :showLoading="false"  label="삭제" icon="remove" @btnClicked="remove" />
            </q-btn-group>
          </template>
          <template slot="card-detail">
            <div class="col-12">
              <c-text
                required
                :editable="editable"
                label="KOSHA 제목"
                name="folderDetailName"
                v-model="folderDetail.folderDetailName"
              />
            </div>
            <div class="col-12">
              <c-text
                required
                :editable="editable"
                label="KOSHA 링크"
                name="folderLink"
                v-model="folderDetail.folderLink"
              />
            </div>
            <!-- <div class="col-3">
              <c-plant
                :required="true"
                :editable="editable"
                type="edit"
                name="plantCd"
                v-model="folderDetail.plantCd" />
            </div> -->
          </template>
        </c-card>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <c-card title="관련 파일" class="cardClassDetailForm">
          <template slot="card-detail">
            <div class="col-12">
              <c-upload
                :attachInfo="attachInfo"
                :editable="editable"
                label="KOSHA 관련 파일">
              </c-upload>
            </div>
          </template>
        </c-card>
      </div>
    </div>
  </q-form>
</template>
<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'kosha-detail',
  props: {
    popupParam: {
      type: Object,
      default(){
        return {
          koshaFolderId: '',
          koshaFolderDetailId: '',
        }
      },
    },
  },
  data() {
    return {
      editable: true,
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'KOSHA_DETAIL',
        taskKey: '',
      },
      folderDetail: {
        koshaFolderDetailId: '',
        koshaFolderId: '',
        folderLink: '',
        folderDetailName: '',
        plantCd: '',
        standardDate: '',
        sortOrder: '',
        deleteFlag: '',
        useFlag: '',
        regUserId: '',
        chgUserId: '',
      },
      disabled: false,
      saveUrl: 'transactionConfig.kosha.folderDetail.insert.url',
      saveType: 'POST',
      isSave: false,
      getUrl: '',
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      getRevUrl: '',
      isRevision: false,
    };
  },

  beforeCreate() {},
  created() {},
  beforeMount() {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    init() {
      this.getUrl = selectConfig.kosha.folderDetail.get.url;
      this.insertUrl = transactionConfig.kosha.folderDetail.insert.url;
      this.updateUrl = transactionConfig.kosha.folderDetail.update.url;
      this.deleteUrl = transactionConfig.kosha.folderDetail.delete.url;

      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.koshaFolderDetailId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.koshaFolderDetailId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          if (_result.data) {
            this.folderDetail = _result.data;
          this.$set(this.attachInfo, 'taskKey', this.popupParam.koshaFolderDetailId)
          }
        },);
      } 
    }, 
    saveFolderDetail() {
      if (this.popupParam.koshaFolderDetailId) {
        this.saveUrl = this.updateUrl;
        this.saveType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.saveType = 'POST';
      }

      this.$refs['editForm'].validate().then(_result => {
        if (_result) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.folderDetail.regUserId = this.$store.getters.user.userId
              this.folderDetail.chgUserId = this.$store.getters.user.userId
              
              this.folderDetail.koshaFolderId = this.popupParam.koshaFolderId

              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    }, 
    saveCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.koshaFolderDetailId = _result.data
      this.$set(this.attachInfo, 'taskKey', this.popupParam.koshaFolderDetailId)
      this.$set(this.attachInfo, 'isSubmit', uid())
      this.getDetail();
    },
    remove() {
       window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.koshaFolderDetailId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
  }
};
</script>